module.exports = __webpack_public_path__ + "static/media/theme-traditional-no-drop-targets.221addf0.svg";